"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  SecureStore: () => SecureStore
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_validate = require("./validate");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneSecureStore");
  return hybrid;
}
function getItem(key, options) {
  (0, import_validate.assertSecureStoreKey)(key, "SecureStore.getItem");
  var checked = (0, import_validate.assertSecureStoreOptions)(options, "SecureStore.getItem");
  return native().getItem(key, checked).then(function(value) {
    return value !== null && value !== void 0 ? value : null;
  }, import_nativeError.rethrowNativeError);
}
function setItem(key, value, options) {
  (0, import_validate.assertSecureStoreKey)(key, "SecureStore.setItem");
  (0, import_validate.assertSecureStoreValue)(value, "SecureStore.setItem");
  var checked = (0, import_validate.assertSecureStoreOptions)(options, "SecureStore.setItem");
  return native().setItem(key, value, checked).catch(import_nativeError.rethrowNativeError);
}
function deleteItem(key, options) {
  (0, import_validate.assertSecureStoreKey)(key, "SecureStore.deleteItem");
  var checked = (0, import_validate.assertSecureStoreOptions)(options, "SecureStore.deleteItem");
  return native().deleteItem(key, checked).catch(import_nativeError.rethrowNativeError);
}
function getItemSync(key, options) {
  (0, import_validate.assertSecureStoreKey)(key, "SecureStore.getItemSync");
  var checked = (0, import_validate.assertSecureStoreOptions)(options, "SecureStore.getItemSync");
  try {
    var _native_getItemSync;
    return (_native_getItemSync = native().getItemSync(key, checked)) !== null && _native_getItemSync !== void 0 ? _native_getItemSync : null;
  } catch (error) {
    (0, import_nativeError.rethrowNativeError)(error);
  }
}
function setItemSync(key, value, options) {
  (0, import_validate.assertSecureStoreKey)(key, "SecureStore.setItemSync");
  (0, import_validate.assertSecureStoreValue)(value, "SecureStore.setItemSync");
  var checked = (0, import_validate.assertSecureStoreOptions)(options, "SecureStore.setItemSync");
  try {
    native().setItemSync(key, value, checked);
  } catch (error) {
    (0, import_nativeError.rethrowNativeError)(error);
  }
}
function deleteItemSync(key, options) {
  (0, import_validate.assertSecureStoreKey)(key, "SecureStore.deleteItemSync");
  var checked = (0, import_validate.assertSecureStoreOptions)(options, "SecureStore.deleteItemSync");
  try {
    native().deleteItemSync(key, checked);
  } catch (error) {
    (0, import_nativeError.rethrowNativeError)(error);
  }
}
var SecureStore = Object.freeze({
  getItem,
  setItem,
  deleteItem,
  getItemSync,
  setItemSync,
  deleteItemSync
});
//# sourceMappingURL=index.native.js.map
